module.exports = __webpack_public_path__ + "img/login_bg2.9ea93d7a.png";